'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.loadNotifications = loadNotifications;
exports.readNotifications = readNotifications;
exports.loadRecentlyBookings = loadRecentlyBookings;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_NOTIFICATIONS = 'redux-frontend/dashboard/LOAD_NOTIFICATIONS';
var LOAD_NOTIFICATIONS_SUCCESS = 'redux-frontend/dashboard/LOAD_NOTIFICATIONS_SUCCESS';
var LOAD_NOTIFICATIONS_FAIL = 'redux-frontend/dashboard/LOAD_NOTIFICATIONS_FAIL';

var LOAD_BOOKINGS = 'redux-frontend/dashboard/LOAD_BOOKINGS';
var LOAD_BOOKINGS_SUCCESS = 'redux-frontend/dashboard/LOAD_BOOKINGS_SUCCESS';
var LOAD_BOOKINGS_FAIL = 'redux-frontend/dashboard/LOAD_BOOKINGS_FAIL';

var initialState = {
  notifications: [],
  bookings: [],
  error: ''
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_NOTIFICATIONS:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_NOTIFICATIONS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        notifications: action.result
      });
    case LOAD_NOTIFICATIONS_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        error: action.error
      });
    case LOAD_BOOKINGS:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_BOOKINGS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        bookings: action.result
      });
    case LOAD_BOOKINGS_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        error: action.error
      });
    default:
      return state;
  }
}

function loadNotifications() {
  return {
    types: [LOAD_NOTIFICATIONS, LOAD_NOTIFICATIONS_SUCCESS, LOAD_NOTIFICATIONS_FAIL],
    promise: function promise(client) {
      return client.get('/users/me/notifications');
    }
  };
}

function readNotifications() {
  return {
    types: [LOAD_NOTIFICATIONS, LOAD_NOTIFICATIONS_SUCCESS, LOAD_NOTIFICATIONS_FAIL],
    promise: function promise(client) {
      return client.post('/users/me/notifications/read').then(function () {
        return client.get('/users/me/notifications');
      });
    }
  };
}

function loadRecentlyBookings() {
  return {
    types: [LOAD_BOOKINGS, LOAD_BOOKINGS_SUCCESS, LOAD_BOOKINGS_FAIL],
    promise: function promise(client) {
      return client.get('/bookings?type=all&limit=3');
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/dashboard.js
// module id = 682
// module chunks = 47